import React, { createContext, useContext } from 'react';

interface SidebarContextType {
  isCollapsed: boolean;
}

const SidebarContext = createContext<SidebarContextType>({ isCollapsed: false });

// Clear any persisted collapsed state from previous versions
localStorage.removeItem('finrite_sidebar_collapsed');

export const SidebarProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <SidebarContext.Provider value={{ isCollapsed: false }}>
      {children}
    </SidebarContext.Provider>
  );
};

export const useSidebar = (): SidebarContextType => {
  return useContext(SidebarContext);
};
